import { useParams } from '@tanstack/react-router';
import { useGetWorkflowDefinition } from 'src/api/rpc/hooks/workflows/useWorkflowDefinitions';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/ui/table';
import { Badge } from 'src/components/ui/badge';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'src/components/ui/card';

export function WorkflowDefinitionStepsTab() {
  const { workflowDefinitionId } = useParams({
    from: '/authenticated/workflows/$workflowDefinitionId',
  });
  const { data: definition, isLoading } =
    useGetWorkflowDefinition(workflowDefinitionId);

  if (isLoading || !definition) {
    return null; // Layout handles loading state
  }

  const steps = definition.steps || [];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Steps ({steps.length})</CardTitle>
      </CardHeader>
      <CardContent>
        {steps.length === 0 ? (
          <p className="text-muted-foreground text-center py-8">
            No steps defined for this workflow.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Category</TableHead>
                <TableHead>Inputs</TableHead>
                <TableHead>Outputs</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {steps.map((step) => (
                <TableRow key={step.id}>
                  <TableCell className="font-medium">{step.name}</TableCell>
                  <TableCell>
                    <Badge variant="outline">{step.type}</Badge>
                  </TableCell>
                  <TableCell>
                    <Badge variant="secondary">{step.category}</Badge>
                  </TableCell>
                  <TableCell>{step.sockets.inputs.length}</TableCell>
                  <TableCell>{step.sockets.outputs.length}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
